class BasicCarousel extends HTMLElement {
    constructor() {
        super()
    }    

    handleScroll = () => {
        const index = Math.round(this.slider.scrollLeft / this.slider.clientWidth);
        this.dots.forEach((dot, i) => dot.classList.toggle("slider-counter__slide-dot--active", i === index));
    }

    handleWindowResize = () => {
        const matchMedia = window.matchMedia("(width <= 750px)");

        if (matchMedia.matches) {
            this.slider.addEventListener("scroll", this.handleScroll, { passive: true });
        } else {
            this.slider.removeEventListener("scroll", this.handleScroll, { passive: true });
        }
    }

    connectedCallback() {
        this.isDisabled = this.getAttribute('data-disabled') === "true"

        if (this.isDisabled) return

        this.slider = this.querySelector(".slider");
        this.dots = this.querySelectorAll(".slider-counter__slide-dot");

        window.addEventListener('resize', this.handleWindowResize)
        this.handleWindowResize()
        this.handleScroll()
    }

    disconnectedCallback() {
        if (isDisabled) return

        this.slider.removeEventListener("scroll", this.handleScroll, { passive: true });
        window.removeEventListener("resize", this.handleWindowResize);
    }
}

customElements.define("basic-carousel", BasicCarousel)